import { render } from "./WebsiteHeader.vue?vue&type=template&id=8d50bca8&scoped=true"
import script from "./WebsiteHeader.vue?vue&type=script&lang=js"
export * from "./WebsiteHeader.vue?vue&type=script&lang=js"

import "./WebsiteHeader.vue?vue&type=style&index=0&id=8d50bca8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d50bca8"]])

export default __exports__